import { routes } from 'routes'
import { reverse } from 'named-urls'
import useForm from 'react-hook-form'
import React, { useEffect } from 'react'
import { Link as RouterLink, useHistory } from 'react-router-dom'
import useSnackbar from 'hooks/useSnackbar'
import useCollapse from 'hooks/useCollapse'
import { Collapse } from 'components'
import CollapseHeader from '../CollapseHeader'
import CollapseBody from '../CollapseBody'

import * as service from 'service'

import { makeStyles } from '@material-ui/styles'
import { RHFInput } from 'react-hook-form-input'
import { KeyboardDatePicker } from '@material-ui/pickers'
import {
  Box,
  Paper,
  Divider,
  FormControlLabel,
  Checkbox,
  Button,
} from '@material-ui/core'

import styles from './styles'
import schema from '../../schemas'

import moment from 'moment'

const useStyles = makeStyles(styles)
const dataSchema = schema.dataSchema

const InvoicesForm = ({ match }) => {
  let contractId = match.params.contractId
  const classes = useStyles()
  const history = useHistory()
  const snackbar = useSnackbar()
  const collapse = useCollapse()
  const { handleSubmit, register, watch, setValue, errors } = useForm({
    validationSchema: dataSchema,
    defaultValues: {
      taxable: true,
    },
  })

  React.useEffect(() => {
    if (collapse.data && collapse.data.length) {
      return
    }

    collapse.add({
      plan: null,
      description: '',
      from: null,
      till: null,
      entryType: '',
      price: 0,
      collapseSettings: { edit: true },
    })
  }, [collapse])

  const handleClickAddItem = () => {
    collapse.add({
      plan: null,
      description: '',
      from: null,
      till: null,
      entryType: '',
      price: 0,
      collapseSettings: { edit: true },
    })
  }

  const disabledAddButton = collapse.data.some(
    invoiceItem => invoiceItem.collapseSettings.edit,
  )

  useEffect(() => {
    register({ name: 'dueDate' })
  }, [register])

  const onSubmit = async separateInvoice => {
    try {
      const invoice = {
        ...separateInvoice,
        invoiceType: 'A',
        items: collapse.data.map(item => ({
          description: item.plan ? item.plan.name : item.description,
          price: item.typeEntry === 'discount' ? -item.price : item.price,
          from: item.from,
          till: item.till,
          planCode: item.plan && item.plan.code,
        })),
      }
      await service.recurrence.invoices.create({ contractId, invoice })

      snackbar.open({
        message: 'Fatura criada com sucesso!',
        variant: 'success',
      })

      history.push(reverse(routes.contracts.show, { contractId }))
    } catch (error) {
      snackbar.open({
        message: 'Erro ao criar fatura!',
        variant: 'error',
      })
    }
  }

  const values = watch()

  return (
    <Box>
      <Paper>
        <Box p={2}>
          <form onSubmit={handleSubmit(onSubmit)} id="invoice-create-form">
            <KeyboardDatePicker
              margin="dense"
              disablePast
              placeholder="Data de vencimento"
              format="dd/MM/yyyy"
              name="dueDate"
              className={classes.customWidth}
              error={errors.dueDate !== undefined}
              helperText={errors.dueDate ? errors.dueDate.message : ''}
              onChange={e =>
                setValue(
                  'dueDate',
                  moment(e)
                    .utc(false)
                    .format(),
                )
              }
              value={values.dueDate || null}
            ></KeyboardDatePicker>
            <RHFInput
              as={
                <FormControlLabel
                  control={<Checkbox />}
                  label="Lançar impostos vinculados à assinatura"
                />
              }
              name="taxable"
              className={classes.checkBox}
              type="checkbox"
              register={register}
              setValue={setValue}
              mode="onChange"
            />
          </form>
        </Box>
      </Paper>
      <Paper className={classes.itemsPaper}>
        <Box p={2}>
          <div className={classes.buttonAddPlan}>
            <Button
              variant="outlined"
              color="primary"
              disabled={disabledAddButton}
              onClick={handleClickAddItem}
            >
              Adicionar item
            </Button>
          </div>
          <Collapse
            collapseHeader={CollapseHeader}
            collapseBody={CollapseBody}
          />
        </Box>
      </Paper>
      <Divider />
      <Box p={2}>
        <Button
          color="primary"
          variant="contained"
          type="submit"
          form="invoice-create-form"
          className={classes.button}
        >
          Cadastrar
        </Button>
        <Button
          component={RouterLink}
          color="primary"
          variant="outlined"
          to={reverse(routes.contracts.show, { contractId })}
        >
          Cancelar
        </Button>
      </Box>
    </Box>
  )
}

export default InvoicesForm
